export default "__VITE_ASSET__BlmyJDzJ__"